import React from 'react';
import { useNavigate } from 'react-router-dom';

const Project = ({ project }) => {
  console.log(project);
  const { _id, picture, heading, subtitle, detail, live, technology } = project

  const navigate = useNavigate();
  const navigateToServiceDetail = (id) => {
    navigate(`/service/${id}`);
  };
  return (
    <div>


      <div class="card card-compact  bg-[#09022265] shadow-2xl min-h-80">
        <figure><img width="100%" className='pt-5' src={picture} alt="Shoes" /></figure>
        <div class="card-body items-center text-center ">
          <h2 className="card-title ">{heading}</h2>
          <p>{subtitle}</p>
          <div >
            <p>Use Technology</p>
            <p className=''><small>{technology}</small></p>
          </div>
          <div class="card-actions justify-center">
            <a href={live} target="_blank" className='btn btn-xs btn-primary '>Demo</a>
            <a href='https://github.com/shahidul7150' target="_blank" className='btn btn-xs btn-primary '>Github</a>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;